import '../styles/pdf-pages.css';
import '../styles/answers-details.css';

import { selectIsAuthenticated } from '@/domain/auth/auth.selectors';
import { ImpactCo2Answer } from '@/domain/impact-co2/entities/question.entity';
import { selectAllImpactCo2Answers } from '@/domain/impact-co2/impact-co2.selectors';
import { selectCurrentProjectFestival } from '@/domain/project-festival/project-festival.selectors';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { formatProjectDatesTz } from '@/ui/utils/format-project-dates';

import CalendarMonthSvg from '../assets/calendar_month.svg';
import { PdfProjectPager } from '../components/PdfProjectPager';

export function PdfFestivalPage5({ totalPages }: { totalPages: number }) {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const festival = useAppSelector(selectCurrentProjectFestival);

  const co2Data = useAppSelector(selectAllImpactCo2Answers).reduce(
    (acc, item) => {
      const { sector, category } = item;
      if (!category || !sector) return acc;
      if (!(sector in acc)) {
        acc[sector] = {};
      }
      if (!(category in acc[sector])) {
        acc[sector][category] = [];
      }
      acc[sector][category].push(item);
      return acc;
    },
    {} as { [key: string]: { [key: string]: ImpactCo2Answer[] } },
  );

  if (!isAuthenticated) {
    return <h1>{translate('PdfExports.user-not-authentified')}</h1>;
  }

  if (!festival) {
    return <h1>{translate('PdfExports.festival-not-found')}</h1>;
  }

  return (
    <div id="page3" className="pdf-page">
      <div className="content">
        <div className="pdf-light-header">
          <div>
            <h1>{festival.name}</h1>
            {festival.startDate && festival.endDate && (
              <h2>
                <img
                  src={CalendarMonthSvg}
                  width="19"
                  height="19"
                  style={{ position: 'relative', top: 4, marginRight: 5 }}
                  alt="Calendar icon"
                />
                <span className="festival-date">
                  {formatProjectDatesTz(
                    festival.startDate || '',
                    festival.endDate || '',
                  )}
                </span>
              </h2>
            )}
          </div>
        </div>
        <div className="pdf-separator"></div>
        <div className="answers-details">
          {/* TODO: rendre la suite de cette page dynamque, en parcourant les données d'entrées.
          On veillera à créer des composants react pour chaque réponse, car en réalité il n'est pas possible
          d'abstraire ces données : chaque réponse a un champ bien particulier. Par ailleurs il ne faudra
          afficher que les réponses renseignées, et masquer celles conditionnées par une QP inactive. */}
          <h2>Réponses aux questionnaires</h2>
          <h3>CO2</h3>
          {Object.entries(co2Data).map(([sectorKey, sectors]) => {
            return (
              <div>
                <h4>{sectorKey}</h4>
                <div className="table-answers">
                  {Object.entries(sectors).map(
                    // eslint-disable-next-line unused-imports/no-unused-vars
                    ([categoryKey, categories]) => {
                      // console.log(
                      //   sectorKey,
                      //   categoryKey,
                      //   JSON.stringify(categories),
                      // );
                      return (
                        <div className="answer-row">
                          <div className="answer-title">
                            <span className="tag-pill black">
                              {/* {translate(
                              `Projects.${sectorKey.toLowerCase()}` as any,
                            )} */}
                            </span>
                            <span className="tag-pill">
                              {
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                translate(`Co2.Sections.${categoryKey}` as any)
                              }
                            </span>
                          </div>
                          <ul className="answers">
                            <li className="answer-value">
                              <h5>Voiture/Van/Taxi thermique</h5>
                              <p>
                                Nombre de personnes :{' '}
                                <span className="highlight">10</span>
                              </p>
                              <p>
                                Nombre de personnes : <span>10</span>
                              </p>
                            </li>
                          </ul>
                        </div>
                      );
                    },
                  )}
                </div>
              </div>
            );
          })}
          {/* <h4>Équipe</h4>
          <div className="table-answers">
            <div className="answer-row">
              <div className="answer-title">
                <span className="tag-pill black">Mobilité</span>
                <span className="tag-pill">Moyen de Transport</span>
              </div>
              <ul className="answers">
                <li className="answer-value">
                  <h5>Voiture/Van/Taxi thermique</h5>
                  <p>
                    Nombre de personnes : <span className="highlight">10</span>
                  </p>
                  <p>
                    Nombre de personnes : <span>10</span>
                  </p>
                </li>
              </ul>
            </div>
            <div className="answer-row">
              <div className="answer-title">
                <span className="tag-pill black">Restauration</span>
                <span className="tag-pill">Type de repas</span>
              </div>
              <ul className="answers">
                <li className="answer-value">
                  <h5>Repas avec poulet - viande blanche</h5>
                  <p>
                    <span className="highlight">10 repas</span>
                  </p>
                </li>
                <li className="answer-value">
                  <h5>Végé</h5>
                  <p>
                    <span className="highlight">10 repas</span>
                  </p>
                </li>
              </ul>
            </div>
          </div> */}
        </div>
      </div>

      <PdfProjectPager current={3} total={totalPages}></PdfProjectPager>
    </div>
  );
}
